export class PasswordFieldState {
    visible: boolean = false

    get type(): string {
        return this.visible ? 'text' : 'password'
    }

    toggle() {
        this.visible = !this.visible
    }
}